import "@Styles/Main.less"

import DataWebPage from "@Scripts/Pages/DataWebPage";
import BasePage from "@Scripts/Pages/BasePage";
import CookiePolicyPage from "@Scripts/Pages/CookiePolicyPage";
import FormHelper from "@Scripts/Common/FormHelper";

let App: any = {
    instances: {},
    pages: {},
    routes: {}
};

App.pages.DataWebPage = DataWebPage;
App.pages.BasePage = BasePage;
App.pages.CookiePolicyPage = CookiePolicyPage;App.FormHelper = FormHelper;

(<any>window).App = App;